import moment from 'moment';
import { isNumberMultipleBy } from './general';
import { jobDurationMinuteInterval, maxWorkingHoursValue, minJobHoursValue } from '../constants/jobs';
import UsersService from '../services/UsersService';

const millisecondsInHour = 3600000;

/**
 *
 * @param {String|Number|Date} dateOne
 * @param {String|Number|Date} dateTwo
 * @return {Boolean}
 */
export function isTimeDifferenceMoreThanOneHour (dateOne, dateTwo) {
  return Math.abs(new Date(dateOne).getTime() - new Date(dateTwo).getTime()) > millisecondsInHour;
}

/**
 *
 * @param {string} dateTimestamp 'YYYY-MM-DDT00:00:00.000Z'
 * @returns {string} 'YYYY-MM-DD'
 *
 * */
export const getDateIgnoringTimeAndTimezone = dateTimestamp => dateTimestamp.substr(0, 10);

/**
 *
 * @param {string} dateTimestamp 'YYYY-MM-DDT00:00:00.000Z' || 'YYYY-MM-DDT00:00:00'
 * @param {string} time '00:00:00'
 * @returns {string} 'YYYY-MM-DDT00:00:00.000Z' || 'YYYY-MM-DDT00:00:00'
 *
 * */
export const combineDateTime = (dateTimestamp, time) => {
  return dateTimestamp.substr(0, 11) + time + dateTimestamp.substr(19);
};

/**
 * @param {string} date
 * @return {object}
 * */
export const setDateFromUrlParam = date => date ? moment(date) : null;

/**
 *
 * @param {Moment} date
 * @param {String} format
 * @return {String}
 */
export const renderDay = (date, format) => {
  const day = date.clone().startOf('day');
  const today = moment().startOf('day');
  const dayBefore = today.clone().subtract(1, 'day');
  const dayAfter = today.clone().add(1, 'day');
  const isYesterday = day.isSame(dayBefore);
  const isToday = day.isSame(today);
  const isTomorrow = day.isSame(dayAfter);

  if (isYesterday) {
    return 'Yesterday';
  } else if (isToday) {
    return 'Today';
  } else if (isTomorrow) {
    return 'Tomorrow';
  }

  return day.format(format);
};

/**
 * @param {string|moment.Moment|Date} date
 * @param {number} [minuteInterval = 15]
 * @return {boolean}
 */
export function isDateMinutesMultipleBy (date, minuteInterval = jobDurationMinuteInterval) {
  return isNumberMultipleBy(moment(date).minute(), minuteInterval);
}

/**
 * @param {string|moment.Moment|Date} start_date
 * @param {string|moment.Moment|Date} end_date
 * @param {number} actual_hours
 * @return {boolean}
 * */
export function isJobTimelineValid (start_date, end_date, actual_hours) {
  if (!start_date || !end_date || !actual_hours) {
    return false;
  }

  const actualHoursInMinutes = actual_hours * 60;

  return (
    isDateMinutesMultipleBy(start_date) &&
    isDateMinutesMultipleBy(end_date) &&
    isNumberMultipleBy(actualHoursInMinutes, jobDurationMinuteInterval) &&
    (UsersService.isAdmin() ? actual_hours > 0 : actual_hours >= minJobHoursValue) &&
    actual_hours <= maxWorkingHoursValue
  );
}



// WEBPACK FOOTER //
// ./src/helpers/date.js